import * as actionTypes from "../actionTypes";

export const getRegisterDetails = () => {
  let query = "";
  return {
    type: actionTypes.GET_REGISTER_DETAILS,
    query,
  };
};

export const saveRegisterDetails = (payload) => {
  return {
    type: actionTypes.SAVE_REGISTER_DETAILS,
    payload,
  };
};

export const saveLoginDetails = (payload) => {
  return {
    type: actionTypes.SAVE_LOGIN_DETAILS,
    payload,
  };
};

export const saveForgotDetails = (payload) => {
  return {
    type: actionTypes.SAVE_FORGOT_DETAILS,
    payload,
  };
};

export const changeIsRegistered = (status) => {
  return {
    type: actionTypes.CHANGE_IS_REGISTERED,
    payload: { is_registered: status },
  };
};

export const initialRegDetails = () => {
  return {
    type: actionTypes.INITIAL_REGISTER_DETAILS,
  };
};
export const userLogout = () => {
  return {
    type: actionTypes.USER_LOGOUT,
  };
};

export const getSetupDetails = (step = 0) => {
  return {
    type: actionTypes.GET_SETUP_DETAILS,
    query: `?step=${step}`,
  };
};

export const getStartedDetails = () => {
  return {
    type: actionTypes.GET_STARTED_DETAILS,
  };
};

export const saveRequestApi = (payload) => {
  return {
    type: actionTypes.SAVE_REQUEST_API,
    payload,
  };
};
export const saveSetupWizardForm = (step, payload, isLogout = false) => {
  return {
    type: actionTypes.SAVE_SETUP_WIZARD_FORM,
    step,
    payload,
    isLogout,
  };
};
export const checkTaxYear = (payload) => {
  return {
    type: actionTypes.CHECK_TAX_YEAR,
    payload,
  };
};
export const getTaxYearEndDate = (payload) => {
  return {
    type: actionTypes.GET_TAX_END_DATE,
    payload,
  };
};
export const changeTaxEndApi = (payload) => {
  return {
    type: actionTypes.CHECK_TAX_YEAR_SUCCEEDED,
    payload,
  };
};
export const saveAccountingPeriod = (
  payload,
  fromTypeId = "",
  fromType = ""
) => {
  return {
    type: actionTypes.SAVE_ACCOUNTING_PERIOD,
    payload,
    fromTypeId,
    fromType,
  };
};
export const savePayrollFreq = (payload) => {
  return {
    type: actionTypes.SAVE_PAYROLL_FREQ,
    payload,
  };
};
export const saveGettingStarted = (payload) => {
  return {
    type: actionTypes.SAVE_GETTING_STARTED,
    payload,
  };
};
export const getAccrualTypes = (id) => {
  return {
    type: actionTypes.GET_ACCRUAL_TYPE,
    query: `/${id}`,
  };
};

export const saveLaborRule = (payload, stats) => {
  return {
    type: actionTypes.SAVE_LABOR_RULE,
    payload,
    stats,
  };
};

export const uploadStaff = (payload) => {
  return {
    type: actionTypes.SAVE_UPLOAD_STAFF,
    payload,
  };
};

export const removeStaff = (query = "") => {
  return {
    type: actionTypes.REMOVE_UPLOAD_STAFF,
    query,
  };
};

export const removePayee = (query = "") => {
  return {
    type: actionTypes.REMOVE_UPLOAD_PAYEE,
    query,
  };
};

export const uploadPayee = (payload) => {
  return {
    type: actionTypes.SAVE_UPLOAD_PAYEE,
    payload,
  };
};

export const downloadStaffTemplate = () => {
  return {
    type: actionTypes.DOWNLOAD_STAFF_TEMP,
    query: "",
  };
};

export const downloadPayeeTemplate = () => {
  return {
    type: actionTypes.DOWNLOAD_PAYEE_TEMP,
    query: "",
  };
};

export const backButtonHandler = (tab = "tab0") => {
  return {
    type: actionTypes.BACK_BTN_HANDLER,
    tab,
  };
};

export const deleteLaborRule = (payload) => {
  return {
    type: actionTypes.DELETE_LABOR_RULE,
    payload,
  };
};

export const getProfileDetailsApi = () => {
  return {
    type: actionTypes.GET_PROFILE_DETAILS,
  };
};

export const applyPromocodeWizard = (payload) => {
  return {
    type: actionTypes.APPLY_PROMO_WIZARD,
    payload,
  };
};
export const removePromocodeWizard = (payload) => {
  return {
    type: actionTypes.REMOVE_PROMO_WIZARD,
    payload,
  };
};
export const userActivation = (payload) => {
  return {
    type: actionTypes.USER_ACTIVATION,
    payload,
  };
};
export const getState = (query = "") => {
  return {
    type: actionTypes.GET_STATE,
    query,
  };
};
